import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  const loadProfile = useCallback(async () => {
    const token = localStorage.getItem('elo_access');
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await authAPI.profile();
      setUser(data);
    } catch {
      localStorage.removeItem('elo_access');
      localStorage.removeItem('elo_refresh');
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { loadProfile(); }, [loadProfile]);

  const login = async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('elo_access',  data.tokens.access);
    localStorage.setItem('elo_refresh', data.tokens.refresh);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await authAPI.logout({ refresh: localStorage.getItem('elo_refresh') }); } catch {}
    localStorage.removeItem('elo_access');
    localStorage.removeItem('elo_refresh');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
